export default __webpack_public_path__ + "static/media/IMG_9994.0a0d50f9.jpg";